export const headerConfig = (headers: any) => {
    try {
        headers.set('Authorization', `Bearer ${JSON.parse(localStorage.getItem('getMe') || '').access}`);
    } catch (e) {}
    return headers
}
